import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=760e47f4&scoped=true&"
import script from "./Endorsements.vue?vue&type=script&lang=js&"
export * from "./Endorsements.vue?vue&type=script&lang=js&"
import style0 from "./Endorsements.vue?vue&type=style&index=0&id=760e47f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e47f4",
  null
  
)

export default component.exports